import StoreCheksV2 from "./storeChecksV2";

export default StoreCheksV2;